import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=24f49ac7&scoped=true&"
import script from "./GlobalNotification.vue?vue&type=script&lang=js&"
export * from "./GlobalNotification.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotification.vue?vue&type=style&index=0&id=24f49ac7&prod&scoped=true&lang=css&"
import style1 from "./GlobalNotification.vue?vue&type=style&index=1&id=24f49ac7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f49ac7",
  null
  
)

export default component.exports